// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-grid {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0 px;
	margin-top: 1rem;
	/* padding: 20px; */
}
.icon-row-container{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0 px;
	margin-top: 1rem;
	/* padding: 20px; */
}


.icon-row {
	display: grid;
	/* grid-template-columns: repeat(5, minmax(50px, 1fr)); */ /* 5 columns per row */
	justify-items: center;
	gap: 0 px;
	border: 2px solid var(--secondary-color1);
    border-radius: 10px;
    margin-top: -8px;
	margin-bottom: 5px;
}

.icon-item {
	padding: 0px;
	/* background-color: #f0f0f0; */
	text-align: center;
	/* border: 1px solid #ddd; */
}

.icon-item.empty {
	background-color: transparent; /* Make empty cells invisible */
	border: none;
}

.tile-select-icons {
	width: 100%;
	/* height: 100px; */
	display: flex;
	flex-direction: row;
	justify-content: center;
	flex-wrap: wrap;
	position: relative;
}

.tile-select-description {
	display: flex;
	flex-direction: column;
}
.tile-select-description p {
	line-height: 1.8rem;
	font-size: 1.4rem;
	text-align: justify;
	margin: 0.5rem;
}

.icons-area {
	width: 100%;
	position: relative;
	height: fit-content;
	max-width: 400px;
	max-height: 100%;
}
.icons-area h1 {
	text-align: center;
}

.panel-content .icons-area img {
	background-color: var(--primary-color1);
	border-radius: 1rem;
	margin: 10%;
	/* z-index: 2000; */
	width: 12.5vw;
	max-width: 30px;
}

.panel-content.icons-area.inactive.twin,
.panel-content.icons-area.twin img {
	background: linear-gradient(135deg, var(--primary-color1) 50%, var(--secondary-color1) 50%);
}

.panel-content.icons-area.active.twin,
.panel-content.icons-area.active.twin img {
	background: linear-gradient(135deg, var(--primary-color2) 50%, var(--tertiary-color2) 50%);
}

.panel-content.icons-area.inactive {
	margin: 1rem;
	background: unset;
	background-color: var(--primary-color1);
	border-radius: 1rem;
	width: 50px;
	height: 50px;
}

.panel-content.icons-area.active {
	margin: 1rem;
	background: unset;
	background-color: var(--primary-color2);
	border-radius: 1rem;
	width: 50px;
	height: 50px;
}
.panel-content.icons-area.active img {
	background: unset;
	background-color: var(--primary-color2);
	border-radius: 1rem;
	/* margin: 1rem; */
	width: 12.5vw;
	max-width: 30px;
}
.icons-area.warning {
	position: absolute;
	top: 10rem;
	left: 0;
	border-radius: 1rem;
	font-size: 1.4rem;
	line-height: 2rem;
	filter: drop-shadow(1px 1px 0.5px black);
	background-color: var(--primary-color1);
	color: white;
	margin: 1rem;
	padding: 1rem;
	text-align: center;
	width: 80%;
}

.icon-row-label {
	font-family: "Inter-Bold", sens-serif;
	font-weight: bold;
	color: var(--secondary-color1);
	width: fit-content;
	height: fit-content;
	padding-left: 5px;
	padding-right: 5px;
	border: 2px solid var(--secondary-color1);
    border-radius: 5px;
	background: none no-repeat scroll 0 0 white;
	margin-left: 10px;
	z-index: 100;
}

.icon-row-label {
	font-family: "Inter-Bold", sens-serif;
	font-weight: bold;
	color: var(--secondary-color1);
	width: fit-content;
	height: fit-content;
	padding-left: 5px;
	padding-right: 5px;
	border: 2px solid var(--secondary-color1);
    border-radius: 5px;
	background: none no-repeat scroll 0 0 white;
	margin-left: 10px;
	z-index: 100;
}

@media (max-width: 300px) {
	.icons-area {
		width: 100%;
		position: relative;
		height: fit-content;
	}
	.icons-area h1 {
		margin-left: 0.5rem;
		text-align: center;
	}
	.tile-select-icons {
		width: 100%;
		/* height: 100px; */
		display: flex;
		flex-direction: row;
		justify-content: center;
		flex-wrap: wrap;
	}
	.panel-content.icons-area,
	.panel-content.icons-area.active {
		margin: 0.25rem;
		border-radius: 1rem;
		width: 40px;
		height: 40px;
	}
	.panel-content.icons-area.inactive {
		margin: 0.25rem;
		background: unset;
		background-color: var(--primary-color1);
		border-radius: 1rem;
		width: 40px;
		height: 40px;
	}
	.panel-content.icons-area.active img {
		width: 10vw;
	}
	.panel-content.icons-area img {
		width: 10vw;
	}
}

@media (min-width: 500px) {
	.tile-select-icons {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.tile-select-description p {
		line-height: 1.8rem;
		font-size: 1.6rem;
		text-align: justify;
		margin: 0.5rem;
	}

	.icons-area {
		width: 300px;
		height: fit-content;
		position: relative;
	}

	.panel-content .icons-area img {
		background: unset;
		background-color: var(--primary-color1);
		border-radius: 1rem;
		margin: 1rem;
		/* z-index: 2000; */
	}

	.panel-content.icons-area {
		margin: 1rem;
		background: unset;
		background-color: var(--primary-color1);
		border-radius: 1rem;
		width: 50px;
	}

	.panel-content .icons-area.active {
		margin: 1rem;
		background: unset;
		background-color: var(--primary-color2);
		border-radius: 1rem;
		width: 50px;
	}
	.panel-content.icons-area.active img {
		background: unset;
		background-color: var(--primary-color2);
		border-radius: 1rem;
		margin: 1rem;
		/* z-index: 2000; */
	}
	.icons-area .warning {
		position: absolute;
		top: 10rem;
		border-radius: 1rem;
		font-size: 1.4rem;
		line-height: 2rem;
		filter: drop-shadow(1px 1px 0.5px black);
		background-color: var(--primary-color1);
		color: white;
	}
	.tile-select-button {
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/TileSelector/TileSelector.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;CACT,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;CACT,gBAAgB;CAChB,mBAAmB;AACpB;;;AAGA;CACC,aAAa;CACb,yDAAyD,EAAE,sBAAsB;CACjF,qBAAqB;CACrB,SAAS;CACT,yCAAyC;IACtC,mBAAmB;IACnB,gBAAgB;CACnB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,+BAA+B;CAC/B,kBAAkB;CAClB,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B,EAAE,+BAA+B;CAC9D,YAAY;AACb;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;AACA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;CACvC,mBAAmB;CACnB,WAAW;CACX,mBAAmB;CACnB,aAAa;CACb,eAAe;AAChB;;AAEA;;CAEC,2FAA2F;AAC5F;;AAEA;;CAEC,0FAA0F;AAC3F;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,uCAAuC;CACvC,mBAAmB;CACnB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,uCAAuC;CACvC,mBAAmB;CACnB,WAAW;CACX,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,uCAAuC;CACvC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,OAAO;CACP,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;CACjB,wCAAwC;CACxC,uCAAuC;CACvC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,qCAAqC;CACrC,iBAAiB;CACjB,8BAA8B;CAC9B,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,yCAAyC;IACtC,kBAAkB;CACrB,2CAA2C;CAC3C,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,qCAAqC;CACrC,iBAAiB;CACjB,8BAA8B;CAC9B,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,yCAAyC;IACtC,kBAAkB;CACrB,2CAA2C;CAC3C,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,mBAAmB;EACnB,kBAAkB;CACnB;CACA;EACC,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;CAChB;CACA;;EAEC,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;CACb;CACA;EACC,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,YAAY;CACb;CACA;EACC,WAAW;CACZ;CACA;EACC,WAAW;CACZ;AACD;;AAEA;CACC;EACC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;CAChB;;CAEA;EACC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;CACf;;CAEA;EACC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;CACpB;;CAEA;EACC,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;CACZ;;CAEA;EACC,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;CACZ;CACA;EACC,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;CACpB;CACA;EACC,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;EACxC,uCAAuC;EACvC,YAAY;CACb;CACA;CACA;AACD","sourcesContent":[".icon-grid {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 0 px;\n\tmargin-top: 1rem;\n\t/* padding: 20px; */\n}\n.icon-row-container{\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 0 px;\n\tmargin-top: 1rem;\n\t/* padding: 20px; */\n}\n\n\n.icon-row {\n\tdisplay: grid;\n\t/* grid-template-columns: repeat(5, minmax(50px, 1fr)); */ /* 5 columns per row */\n\tjustify-items: center;\n\tgap: 0 px;\n\tborder: 2px solid var(--secondary-color1);\n    border-radius: 10px;\n    margin-top: -8px;\n\tmargin-bottom: 5px;\n}\n\n.icon-item {\n\tpadding: 0px;\n\t/* background-color: #f0f0f0; */\n\ttext-align: center;\n\t/* border: 1px solid #ddd; */\n}\n\n.icon-item.empty {\n\tbackground-color: transparent; /* Make empty cells invisible */\n\tborder: none;\n}\n\n.tile-select-icons {\n\twidth: 100%;\n\t/* height: 100px; */\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\tflex-wrap: wrap;\n\tposition: relative;\n}\n\n.tile-select-description {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n.tile-select-description p {\n\tline-height: 1.8rem;\n\tfont-size: 1.4rem;\n\ttext-align: justify;\n\tmargin: 0.5rem;\n}\n\n.icons-area {\n\twidth: 100%;\n\tposition: relative;\n\theight: fit-content;\n\tmax-width: 400px;\n\tmax-height: 100%;\n}\n.icons-area h1 {\n\ttext-align: center;\n}\n\n.panel-content .icons-area img {\n\tbackground-color: var(--primary-color1);\n\tborder-radius: 1rem;\n\tmargin: 10%;\n\t/* z-index: 2000; */\n\twidth: 12.5vw;\n\tmax-width: 30px;\n}\n\n.panel-content.icons-area.inactive.twin,\n.panel-content.icons-area.twin img {\n\tbackground: linear-gradient(135deg, var(--primary-color1) 50%, var(--secondary-color1) 50%);\n}\n\n.panel-content.icons-area.active.twin,\n.panel-content.icons-area.active.twin img {\n\tbackground: linear-gradient(135deg, var(--primary-color2) 50%, var(--tertiary-color2) 50%);\n}\n\n.panel-content.icons-area.inactive {\n\tmargin: 1rem;\n\tbackground: unset;\n\tbackground-color: var(--primary-color1);\n\tborder-radius: 1rem;\n\twidth: 50px;\n\theight: 50px;\n}\n\n.panel-content.icons-area.active {\n\tmargin: 1rem;\n\tbackground: unset;\n\tbackground-color: var(--primary-color2);\n\tborder-radius: 1rem;\n\twidth: 50px;\n\theight: 50px;\n}\n.panel-content.icons-area.active img {\n\tbackground: unset;\n\tbackground-color: var(--primary-color2);\n\tborder-radius: 1rem;\n\t/* margin: 1rem; */\n\twidth: 12.5vw;\n\tmax-width: 30px;\n}\n.icons-area.warning {\n\tposition: absolute;\n\ttop: 10rem;\n\tleft: 0;\n\tborder-radius: 1rem;\n\tfont-size: 1.4rem;\n\tline-height: 2rem;\n\tfilter: drop-shadow(1px 1px 0.5px black);\n\tbackground-color: var(--primary-color1);\n\tcolor: white;\n\tmargin: 1rem;\n\tpadding: 1rem;\n\ttext-align: center;\n\twidth: 80%;\n}\n\n.icon-row-label {\n\tfont-family: \"Inter-Bold\", sens-serif;\n\tfont-weight: bold;\n\tcolor: var(--secondary-color1);\n\twidth: fit-content;\n\theight: fit-content;\n\tpadding-left: 5px;\n\tpadding-right: 5px;\n\tborder: 2px solid var(--secondary-color1);\n    border-radius: 5px;\n\tbackground: none no-repeat scroll 0 0 white;\n\tmargin-left: 10px;\n\tz-index: 100;\n}\n\n.icon-row-label {\n\tfont-family: \"Inter-Bold\", sens-serif;\n\tfont-weight: bold;\n\tcolor: var(--secondary-color1);\n\twidth: fit-content;\n\theight: fit-content;\n\tpadding-left: 5px;\n\tpadding-right: 5px;\n\tborder: 2px solid var(--secondary-color1);\n    border-radius: 5px;\n\tbackground: none no-repeat scroll 0 0 white;\n\tmargin-left: 10px;\n\tz-index: 100;\n}\n\n@media (max-width: 300px) {\n\t.icons-area {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\theight: fit-content;\n\t}\n\t.icons-area h1 {\n\t\tmargin-left: 0.5rem;\n\t\ttext-align: center;\n\t}\n\t.tile-select-icons {\n\t\twidth: 100%;\n\t\t/* height: 100px; */\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: center;\n\t\tflex-wrap: wrap;\n\t}\n\t.panel-content.icons-area,\n\t.panel-content.icons-area.active {\n\t\tmargin: 0.25rem;\n\t\tborder-radius: 1rem;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t}\n\t.panel-content.icons-area.inactive {\n\t\tmargin: 0.25rem;\n\t\tbackground: unset;\n\t\tbackground-color: var(--primary-color1);\n\t\tborder-radius: 1rem;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t}\n\t.panel-content.icons-area.active img {\n\t\twidth: 10vw;\n\t}\n\t.panel-content.icons-area img {\n\t\twidth: 10vw;\n\t}\n}\n\n@media (min-width: 500px) {\n\t.tile-select-icons {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.tile-select-description p {\n\t\tline-height: 1.8rem;\n\t\tfont-size: 1.6rem;\n\t\ttext-align: justify;\n\t\tmargin: 0.5rem;\n\t}\n\n\t.icons-area {\n\t\twidth: 300px;\n\t\theight: fit-content;\n\t\tposition: relative;\n\t}\n\n\t.panel-content .icons-area img {\n\t\tbackground: unset;\n\t\tbackground-color: var(--primary-color1);\n\t\tborder-radius: 1rem;\n\t\tmargin: 1rem;\n\t\t/* z-index: 2000; */\n\t}\n\n\t.panel-content.icons-area {\n\t\tmargin: 1rem;\n\t\tbackground: unset;\n\t\tbackground-color: var(--primary-color1);\n\t\tborder-radius: 1rem;\n\t\twidth: 50px;\n\t}\n\n\t.panel-content .icons-area.active {\n\t\tmargin: 1rem;\n\t\tbackground: unset;\n\t\tbackground-color: var(--primary-color2);\n\t\tborder-radius: 1rem;\n\t\twidth: 50px;\n\t}\n\t.panel-content.icons-area.active img {\n\t\tbackground: unset;\n\t\tbackground-color: var(--primary-color2);\n\t\tborder-radius: 1rem;\n\t\tmargin: 1rem;\n\t\t/* z-index: 2000; */\n\t}\n\t.icons-area .warning {\n\t\tposition: absolute;\n\t\ttop: 10rem;\n\t\tborder-radius: 1rem;\n\t\tfont-size: 1.4rem;\n\t\tline-height: 2rem;\n\t\tfilter: drop-shadow(1px 1px 0.5px black);\n\t\tbackground-color: var(--primary-color1);\n\t\tcolor: white;\n\t}\n\t.tile-select-button {\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
